import React from 'react'
import { getObjectiveIcons } from '@/modules/settings/services/uiIconService'

type Props = { objective?: string | null; className?: string }

export default function ObjectiveIcon({ objective, className }: Props) {
  const [urls, setUrls] = React.useState<{ bull: string; bear: string } | null>(null)
  React.useEffect(() => {
    let mounted = true
    getObjectiveIcons().then((u) => { if (mounted) setUrls(u) }).catch(() => {})
    return () => { mounted = false }
  }, [])
  const o = String(objective || '').toLowerCase()
  const src = o === 'long' ? urls?.bull : o === 'short' ? urls?.bear : undefined
  if (!src) return null
  return (
    <img
      src={src}
      alt={o === 'long' ? 'bull' : 'bear'}
      className={["inline-block h-4 w-4", className || ''].join(' ').trim()}
      loading="lazy"
      decoding="async"
    />
  )
}
